import { useEffect } from 'react'

type KeyHandler = (e: KeyboardEvent) => void

export const useKeyPress = (
  keyCode: number,
  handler: KeyHandler,
  dependencies: any[] = []
) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.keyCode === keyCode) {
        handler(e)
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, dependencies)
}
